import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const BloodApplicationsPage = lazy(
  () => import('@/pages/blood-applications/ui/index'),
)

export const Route = createFileRoute('/_protected/warehouse/applications')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <BloodApplicationsPage />
    </Suspense>
  ),
})
